// Import necessary dependencies and utilities
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";
import { transformRequest } from "../../utils/API/requestMiddleware";


const groupManagementAPI = createApi({
    reducerPath: "groupManagementAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({
        groupManagementList: builder.mutation({
            query: (groupQuery) => ({
                url: '/GroupManagement/GetAllGroupManagementList',
                method: 'POST',
                body: transformRequest(groupQuery)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getGroupManagementById: builder.query({
            query: (data) => ({
                url: `/GroupManagement/GetGroupManagementById?groupId=${data}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addEditGroup: builder.mutation({
            query: (Details) => ({
                url: '/GroupManagement/AddEditGroupManagement',
                method: 'POST',
                body: transformRequest(Details)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        deleteGroup: builder.mutation({
            query: (id) => ({
                url: `/GroupManagement/DeleteGroupManagementById?id=${id}`,
                method: 'DELETE',
                body: transformRequest(id)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        exportTimesheetReportListByGroupWise: builder.query({
            query: (data) => ({
                url: `/GroupManagement/ExportTimesheetReportByGroupWise`,
                method: 'post',
                body: transformRequest(data), 
                responseHandler: (response) => response.blob(),
            }),
        }),

    })
})

export const {
    useGroupManagementListMutation,
    useLazyGetGroupManagementByIdQuery,
    useAddEditGroupMutation,
    useDeleteGroupMutation,
    useLazyExportTimesheetReportListByGroupWiseQuery
} = groupManagementAPI;

export default groupManagementAPI;